import React, { cloneElement } from 'react';
import { InfoIcon, PenToolIcon, FileTextIcon, LightbulbIcon, GlobeIcon, CalendarIcon, GraduationCapIcon, SmileIcon, HeartIcon, UtensilsIcon, PlaneIcon, CalculatorIcon, BriefcaseIcon, ShoppingBagIcon, UsersIcon } from 'lucide-react';
const UseCases = () => {
  const useCaseCategories = [{
    title: 'Info & Facts',
    icon: <InfoIcon className="h-6 w-6" data-id="element-390" />,
    examples: ['Difference between baking soda & baking powder?', 'Population of Tokyo?']
  }, {
    title: 'Writing Help',
    icon: <PenToolIcon className="h-6 w-6" data-id="element-391" />,
    examples: ['Write a polite follow-up email to a client.', 'Make this paragraph sound friendlier.']
  }, {
    title: 'Summarizing & Explaining',
    icon: <FileTextIcon className="h-6 w-6" data-id="element-392" />,
    examples: ['Summarize this report in 5 bullet points.', 'Explain compound interest for a 12-year-old.']
  }, {
    title: 'Brainstorming Ideas',
    icon: <LightbulbIcon className="h-6 w-6" data-id="element-393" />,
    examples: ['20 creative coffee shop names.', 'Fun date night ideas in the city.']
  }, {
    title: 'Translation & Language Learning',
    icon: <GlobeIcon className="h-6 w-6" data-id="element-394" />,
    examples: ['Translate to Spanish, keep it casual.', 'Teach me 10 common French travel phrases.']
  }, {
    title: 'Planning & Organization',
    icon: <CalendarIcon className="h-6 w-6" data-id="element-395" />,
    examples: ['Grocery list for 5 easy dinners.', 'Packing checklist for 4-day hiking trip.']
  }, {
    title: 'Learning & Skills',
    icon: <GraduationCapIcon className="h-6 w-6" data-id="element-396" />,
    examples: ['Daily 15-min Spanish practice plan.', 'Walk me through solving algebra basics.']
  }, {
    title: 'Entertainment & Fun',
    icon: <SmileIcon className="h-6 w-6" data-id="element-397" />,
    examples: ['Tell me a short, clean cat joke.', 'Make a tricky but solvable riddle.']
  }, {
    title: 'Personal Tips',
    icon: <HeartIcon className="h-6 w-6" data-id="element-398" />,
    examples: ['Best way to clean stainless steel pan?', 'Quick desk posture exercises.']
  }, {
    title: 'Recipes & Cooking',
    icon: <UtensilsIcon className="h-6 w-6" data-id="element-399" />,
    examples: ['I have chicken, spinach, pasta — recipe?', 'Banana bread step-by-step.']
  }, {
    title: 'Travel Tips',
    icon: <PlaneIcon className="h-6 w-6" data-id="element-400" />,
    examples: ['Fastest way JFK → Times Square?', 'Must-try street foods in Bangkok.']
  }, {
    title: 'Math & Conversions',
    icon: <CalculatorIcon className="h-6 w-6" data-id="element-401" />,
    examples: ['Convert 5 cups flour to grams.', "What's 15% of 680?"]
  }, {
    title: 'Work & Productivity',
    icon: <BriefcaseIcon className="h-6 w-6" data-id="element-402" />,
    examples: ['Meeting agenda for 30-min marketing update.', 'Summarize this customer feedback.']
  }, {
    title: 'Shopping Help',
    icon: <ShoppingBagIcon className="h-6 w-6" data-id="element-403" />,
    examples: ['iPhone 15 vs Samsung S24 pros/cons?', 'Best travel backpack under $100.']
  }, {
    title: 'Kids & Family',
    icon: <UsersIcon className="h-6 w-6" data-id="element-404" />,
    examples: ['Indoor rainy-day activities for kids.', 'Bedtime story about a space-traveling dog.']
  }];
  return <section className="py-16 bg-gray-50" data-id="element-405">
      <div className="container mx-auto px-4" data-id="element-406">
        <div className="text-center mb-12" data-id="element-407">
          <h2 className="text-3xl font-bold mb-4" data-id="element-408">What It Can Help With</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-409">
            From answering simple questions to helping with complex tasks, Voxie
            can assist users with a wide range of needs.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-410">
          {useCaseCategories.map((category, index) => <div key={index} className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow p-6 border border-gray-200" data-id="element-411">
              <div className="flex items-center mb-4" data-id="element-412">
                <div className="bg-[#e5f8f7] p-3 rounded-full mr-3" data-id="element-413">
                  {cloneElement(category.icon, {
                className: 'h-6 w-6 text-[#54d4cb]'
              })}
                </div>
                <h3 className="text-xl font-semibold" data-id="element-414">{category.title}</h3>
              </div>
              <ul className="space-y-3" data-id="element-415">
                {category.examples.map((example, idx) => <li key={idx} className="bg-gray-50 p-3 rounded-md text-gray-700 text-sm" data-id="element-416">
                    "{example}"
                  </li>)}
              </ul>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-417">
          <p className="text-gray-600 mb-6" data-id="element-418">
            And thousands more use cases to help users in their daily lives
          </p>
          <a href="#try-voxie" className="bg-[#54d4cb] text-white px-6 py-3 rounded-md font-medium hover:bg-[#43aca5] transition-colors inline-block" data-id="element-419">
            Try Voxie Today
          </a>
        </div>
      </div>
    </section>;
};
export default UseCases;